module.exports = __webpack_public_path__ + "static/media/arrow_down-icon--white.93062bcd.svg";